import { Registration } from "./pages/Registration/Registration";
import { Login } from "./pages/LoginPage/Login";
import { MainNavigation } from "./component/Navigation/MainNavigation/MainNavigation";
import Main from "./Main";
import Condition from "./pages/Condition/Condition";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ResetPasswordForm from "./pages/LoginPage/ResetPasswordForm";
import Billing from "./pages/Billing/billing";

export const RoutingApp = () => {
  return (
    <div>
      <Routes
        future={{
          v7_relativeSplatPath: true,
        }}
      >
        <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/reset-pass"
          element={<ResetPasswordForm />}
        />
        <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/"
          element={<MainNavigation />}
        />
        <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/login"
          element={<Login />}
        />
        <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/registration"
          element={<Registration />}
        />
        {/* <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/billing-upgrade"
          element={<Billing />}
        /> */}

        <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/privacy-policy"
          element={<Condition />}
        />
        <Route
          future={{
            v7_relativeSplatPath: true,
          }}
          path="/*"
          element={<Main />}
        />
      </Routes>
    </div>
  );
};
